import axiosClient from 'config/axiosClient';

const _url = '/Api/SemesterTuition';
const semesterTuitionService = {

    downloadTemplate: () => {
        return axiosClient.get(_url + '/Template', {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type':
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
        });
    },
    import: (data : any) => {
        return axiosClient.post(_url + '/Import', data);
    },
    export: (data : any) => {
        return axiosClient.post(_url + '/Export', data, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type':
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
        });
    }
};

export default semesterTuitionService;
